import { Redirect } from 'expo-router';
import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import { isMobileBrowser, isWeb } from 'shared/constants/platform';
import { useAnalyticsConfiguration } from 'shared/hooks/analytics/useAnalyticsConfiguration';
import { useViewDidFocusLogScreenAnalytics } from 'shared/hooks/analytics/useViewDidFocusAnalytics';
import ActionScreen from 'shared/patterns/vxl/ActionScreen/ActionScreen';

export const OpenApp = () => {
  const { t: translatedText } = useTranslation('plaidStrings', {
    keyPrefix: 'openApp',
  });

  const { segmentClient } = useAnalyticsConfiguration();

  // if, for some reason, we manage to reach this url in the mobile app or within
  // a desktop browser we are in a 'redundant state' because the app is already
  // considered open. In this case we redirect to home.
  const isAppAlreadyOpen = !isWeb || !isMobileBrowser;

  const analyticsPayload = useMemo(
    () => ({
      name: 'Open App Landing Page',
      // device / user agent meta is automatically captured by amplitude.
      properties: {
        is_mobile_app: (!isWeb).toString(),
        is_mobile_browser: isMobileBrowser.toString(),
      },
    }),
    [],
  );

  useViewDidFocusLogScreenAnalytics(
    !isAppAlreadyOpen ? analyticsPayload : null,
  );

  // focus events are not trigged for redirects, so log screen event here in the
  // case we are redirecting:
  useEffect(() => {
    if (isAppAlreadyOpen) {
      void segmentClient.logEvent(
        'Open App Landing Page Redirect',
        analyticsPayload.properties,
      );
    }
  }, [isAppAlreadyOpen, segmentClient, analyticsPayload]);

  if (isAppAlreadyOpen) {
    return <Redirect href="/" />;
  }

  return (
    <ActionScreen
      visual="PHONE_A"
      titleText={translatedText('title')}
      titleTextStyle="large"
      bodyContent={<BodyBaseText>{translatedText('body')}</BodyBaseText>}
    />
  );
};

export default OpenApp;
